// eslint-disable-next-line no-restricted-imports
import { ApolloLink, type Operation } from "@apollo/client";
import type { DefinitionNode } from "graphql";

import { captureBreadcrumb, type SeverityLevel } from "util/exception";

function captureGraphQLBreadcrumb(
  message: string,
  data: Record<string, unknown> = {},
  level: SeverityLevel = "info",
) {
  captureBreadcrumb({ message, data, level, category: "GraphQL" });
}

function getFormattedType([firstDefinition]: Readonly<(DefinitionNode | undefined)[]>): string {
  if (!firstDefinition) {
    return "Unknown";
  }
  if (firstDefinition.kind !== "OperationDefinition") {
    return firstDefinition.kind;
  }
  return firstDefinition.operation;
}

function formatMessage({ operationName, query: { definitions } }: Operation, isStart: boolean) {
  const beginOrEnd = isStart ? "Start" : "End";
  return `${beginOrEnd} ${getFormattedType(definitions)} ${operationName}`;
}

export function createSentryBreadcrumbLink() {
  return new ApolloLink((operation, forward) => {
    const startTime = new Date().getTime();
    captureGraphQLBreadcrumb(formatMessage(operation, true));

    return forward(operation).map((result) => {
      const elapsedTime = new Date().getTime() - startTime;
      const extra = { elapsedTime: `${elapsedTime}ms` };
      // This may not be accurate due to the mutation response begining "successful"
      // with metalab bs `errors` field in the response.
      const level = result.errors ? "error" : "info";
      captureGraphQLBreadcrumb(formatMessage(operation, false), extra, level);
      return result;
    });
  });
}
